import { PollenProvider } from '../providers/pollenProvider.js';

export const GET_POLLEN_BY_LATLON = 'GET_POLLEN_BY_LATLON';
export const GET_POLLEN_BY_LATLON_FULFILLED = 'GET_POLLEN_BY_LATLON_FULFILLED';
export const GET_POLLEN_BY_LATLON_REJECTED = 'GET_POLLEN_BY_LATLON_REJECTED';

export function getPollenByLatLon(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose) {
    return {
        type: GET_POLLEN_BY_LATLON,
        payload: getPollen(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose)
    };
}

function getPollen(latitude, longitude, baseUrl, authId, secret, stdParameters, verbose) {
    return new Promise((resolve, reject) => {
        const op = new PollenProvider(baseUrl, authId, secret);
        op.getPollen(latitude, longitude, stdParameters, verbose)
            .then(results => {
                resolve(results);
            }).catch(error => {
                console.log('PollenProvider.getPollen() error:', error);
                reject(error);
            });
    });
}
